const SOUNDS_CONFIG = {
  enabled: true,
  masterVolume: 0.5,
  musicVolume: 0.3,
  jumpSoundVolume: 0.3,
  collectSoundVolume: 0.7,
  smashSoundVolume: 0.8,
  deathSoundVolume: 1,
  obstacleFallSoundVolume: 0.7,
  gameOverSoundVolume: 0.7,
  clickSoundVolume: 1.3,
}

export { SOUNDS_CONFIG };
